import { jsx as _jsx } from "react/jsx-runtime";
import { renderFallback, getFontWeightClass, getTextTransformClass } from "../utils";
import { createColumnHeader } from "./column-header";
import { TruncatedText } from "../TruncatedText";
/**
 * Create a text column with optional formatting
 */ export function createTextColumn(accessorKey, title, options = {}) {
    const { fontWeight, transform, fallback = "-", className = "", sticky, enableSorting = true, enableFiltering = false, customRender, fitContent, truncate = false } = options;
    // Build combined CSS class using utility functions
    const combinedClassName = [
        getFontWeightClass(fontWeight),
        getTextTransformClass(transform),
        className
    ].filter(Boolean).join(" ");
    return {
        accessorKey,
        meta: {
            label: title,
            sticky,
            fitContent,
            ...enableFiltering && {
                filterType: "text"
            }
        },
        header: createColumnHeader(title),
        cell: ({ row })=>{
            const value = row.getValue(accessorKey);
            if (truncate && !customRender) {
                return /*#__PURE__*/ _jsx(TruncatedText, {
                    text: value == null ? null : String(value),
                    className: combinedClassName || undefined,
                    fallback: fallback
                });
            }
            const content = customRender ? customRender(value, row.original) : renderFallback(value, fallback);
            return combinedClassName ? /*#__PURE__*/ _jsx("span", {
                className: combinedClassName,
                children: content
            }) : content;
        },
        enableSorting,
        enableColumnFilter: enableFiltering
    };
}

//# sourceMappingURL=text-column.js.map